module.exports = __webpack_public_path__ + "static/media/silueta_david.d8ee8bcf.png";